var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponentfailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 181,
    viewBox: "0 0 142 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9325 0.640106C79.451 0.640106 86.9144 4.3456 91.057 9.89852H91.2209C117.028 47.1244 127.182 94.7856 129.458 115.76C129.969 118.694 130.235 121.704 130.235 124.773C130.235 155.473 103.624 180.36 70.7975 180.36C37.971 180.36 11.3599 155.473 11.3599 124.773C11.3599 121.999 11.5772 119.272 11.9968 116.607C12.5865 106.804 14.1251 97.0757 16.296 87.6768C14.1322 88.9242 11.4211 90.6603 8.98997 92.5716C7.45238 93.7804 6.05051 95.0408 4.9736 96.2744C3.88207 97.5247 3.19898 98.6636 2.97414 99.6272C2.84178 100.194 2.27462 100.547 1.70736 100.415C1.1401 100.282 0.787552 99.7151 0.919918 99.1478C1.26028 97.6892 2.20546 96.2377 3.38454 94.8871C4.57824 93.5197 6.08931 92.1687 7.68628 90.9133C10.8806 88.4021 14.5134 86.1993 16.8929 84.9325C16.9143 84.9212 16.9359 84.9106 16.9577 84.9008C25.1806 51.4348 41.1352 22.5257 50.2247 9.89852H50.808C54.9506 4.3456 62.4139 0.640106 70.9325 0.640106ZM70.9226 7.34207C78.8058 7.34207 85.7125 10.7712 89.5461 15.91H89.6978C113.58 50.3594 122.977 94.4659 125.083 113.876C125.556 116.591 125.802 119.377 125.802 122.217C125.802 150.627 101.176 173.658 70.7977 173.658C40.4195 173.658 15.7931 150.627 15.7931 122.217C15.7931 119.649 15.9942 117.126 16.3824 114.66C18.9395 72.1558 40.7705 31.1755 51.7592 15.91H52.299C56.1326 10.7712 63.0393 7.34207 70.9226 7.34207Z",
    fill: "#DCDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4791 12.4506C86.464 7.06867 79.2305 3.47729 70.9743 3.47729C62.7181 3.47729 55.4846 7.06867 51.4695 12.4506H50.9043C39.3956 28.4384 16.5316 71.3578 13.8536 115.873C13.4469 118.456 13.2363 121.098 13.2363 123.787C13.2363 153.542 39.028 177.662 70.8435 177.662C102.659 177.662 128.451 153.542 128.451 123.787C128.451 120.813 128.193 117.895 127.697 115.052C125.491 94.7234 115.65 48.5301 90.638 12.4506H90.4791ZM89.0148 18.2771C85.2992 13.2966 78.6052 9.97305 70.9647 9.97305C63.3243 9.97305 56.6303 13.2966 52.9147 18.2771H52.3916C41.7413 33.0725 20.5825 72.7908 18.1042 113.986C17.7279 116.376 17.533 118.822 17.533 121.31C17.533 148.845 41.401 171.167 70.8437 171.167C100.286 171.167 124.154 148.845 124.154 121.31C124.154 118.558 123.916 115.858 123.457 113.226C121.416 94.4138 112.308 51.6657 89.1618 18.2771H89.0148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1083 74.7342C77.1083 74.991 77.0918 75.2442 77.0596 75.4931C77.0003 75.9518 76.586 76.2617 76.1235 76.2617H75.4147C75.2417 76.2617 75.1014 76.1215 75.1014 75.9485V75.6428C75.1014 75.6386 75.1048 75.6352 75.109 75.6352C75.1124 75.6352 75.1153 75.633 75.1162 75.6297C75.2111 75.2736 75.2615 74.9014 75.2615 74.5183C75.2615 71.9576 73.0122 69.8819 70.2376 69.8819C67.463 69.8819 65.2138 71.9576 65.2138 74.5183C65.2138 74.9014 65.2641 75.2737 65.359 75.6297C65.3599 75.633 65.3628 75.6352 65.3662 75.6352C65.3703 75.6352 65.3736 75.6386 65.3736 75.6427V75.9485C65.3736 76.1215 65.2334 76.2617 65.0604 76.2617H64.3516C63.889 76.2617 63.4747 75.9518 63.4154 75.493C63.3832 75.2442 63.3667 74.991 63.3667 74.7342C63.3667 71.2322 66.4429 68.3932 70.2375 68.3932C74.0322 68.3932 77.1083 71.2322 77.1083 74.7342Z",
    fill: "#060007"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3523,
    cy: 58.5789,
    r: 5.4216,
    fill: "#060007"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5666,
    cy: 57.2541,
    r: 2.24991,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5723,
    cy: 65.0364,
    r: 4.4983,
    fill: "#F15412"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.4216,
    cy: 5.4216,
    r: 5.4216,
    transform: "matrix(-1 0 0 1 94.9604 52.3495)",
    fill: "#060007"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.24991,
    cy: 2.24991,
    r: 2.24991,
    transform: "matrix(-1 0 0 1 90.5745 54.1963)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4983,
    cy: 4.4983,
    r: 4.4983,
    transform: "matrix(-1 0 0 1 100.817 59.7303)",
    fill: "#F15412"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.4127,
    cy: 123.782,
    rx: 29.7228,
    ry: 36.5961,
    fill: "#E1F2C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.108 97.2632C136.493 93.3907 128.02 85.6862 123.048 85.8481",
    stroke: "#DCDCDC",
    strokeWidth: 2.10941,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentfailed);
export default __webpack_public_path__ + "static/media/componentfailed.e41cbb977e8fd5d95350f149e6772238.svg";
export { ForwardRef as ReactComponent };